import React from "react";
import { connect } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";

const Progress = ({ portionsToLoad, portionsLoaded }) => {
  if (portionsToLoad === 0) {
    return null;
  } else {
    const value = (portionsLoaded * 100) / portionsToLoad;
    return <LinearProgress variant="determinate" value={value} />;
  }
};

function mapStateToProps({ data }) {
  return {
    portionsToLoad: data.get("portionsToLoad"),
    portionsLoaded: data.get("portionsLoaded")
  };
}

export default connect(mapStateToProps)(Progress);



// WEBPACK FOOTER //
// ./src/components/progress/index.js